import React, { useState, useEffect } from "react";

export default function Settings(props) {
  const [state, setState] = useState(null);

  return <div>Settings</div>;
}
